import { buildSelector } from '@/shared/lib/store';

import { initialState } from '../slices/pattern-lab.slice';
import type { PatternLabSchema } from '../types/pattern-lab.schema';

export const [useStudiedPatterns] = buildSelector<PatternLabSchema, []>(
    (state) => state.patternLab ?? initialState,
);
